export default __webpack_public_path__ + "static/media/ea4c2b6f5b7fc1393ecb353653a5b0a01582053885862.11b989f1.webp";